import { LoadingState, VAlert } from '@vrzl/ui';
import type { ReactNode } from 'react';

import { useMe } from '@/domains/sync/api/me';

export function AdminGuard({ children }: { children: ReactNode }) {
  const { data, isPending } = useMe();

  if (isPending) {
    return <LoadingState className="min-h-[50vh]" />;
  }

  if (!data?.isAdmin) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center p-6">
        <div className="w-full max-w-lg">
          <VAlert variant="error" title="Geen toegang">
            Je hebt geen beheerdersrechten voor deze omgeving.
          </VAlert>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
